import {
  GET_PAYROLL_DOCUMENTS, GET_PAYROLL_DOCUMENTS_SUCCESS, GET_PAYROLL_DOCUMENTS_FAILURE,
  GET_PAYROLL_DOCUMENT, GET_PAYROLL_DOCUMENT_SUCCESS, GET_PAYROLL_DOCUMENT_FAILURE,
  IMPORT_PAYROLL_DOCUMENTS, IMPORT_PAYROLL_DOCUMENTS_SUCCESS, IMPORT_PAYROLL_DOCUMENTS_FAILURE,
  UPDATE_PAYROLL_EXCLUDED, UPDATE_PAYROLL_EXCLUDED_SUCCESS, UPDATE_PAYROLL_EXCLUDED_FAILURE,
  GET_PAYROLL_DOWNLOAD_URL, GET_PAYROLL_DOWNLOAD_URL_FAILURE
} from './mutation-types'
import constant from '../constant'

//
// 給与・賞与明細（F-PAY-01 / F-PAY-03）
//
export default {
  state: {
    payrollDocuments: null,
    payrollDocument: null,
    payrollImportResult: null,
    payrollNotify: null,
    payrollForbidden: false
  },
  getters: {
    payrollDocuments: state => {
      return state.payrollDocuments
    },
    payrollDocument: state => {
      return state.payrollDocument
    },
    payrollImportResult: state => {
      return state.payrollImportResult
    },
    payrollNotify: state => {
      return state.payrollNotify
    },
    payrollForbidden: state => {
      return state.payrollForbidden
    }
  },
  actions: {
    // 明細一覧
    [GET_PAYROLL_DOCUMENTS] ({dispatch, state, commit}, params = null) {
      var data = params ? params.data : {}
      state.payrollForbidden = false
      return dispatch('apiGet', {url: '/master/payroll/documents', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_PAYROLL_DOCUMENTS_FAILURE, res.data)
          } else {
            commit(GET_PAYROLL_DOCUMENTS_SUCCESS, {data: res.data, callback: params ? params.callback : null})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.payrollForbidden = true
        }
        commit(GET_PAYROLL_DOCUMENTS_FAILURE, {})
        if (params && params.callback) params.callback()
      })
    },
    // 明細の内容
    [GET_PAYROLL_DOCUMENT] ({dispatch, state, commit}, params) {
      state.payrollForbidden = false
      return dispatch('apiGet', {url: '/master/payroll/documents/' + params.id, data: {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_PAYROLL_DOCUMENT_FAILURE, res.data)
          } else {
            commit(GET_PAYROLL_DOCUMENT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.payrollForbidden = true
        }
        commit(GET_PAYROLL_DOCUMENT_FAILURE, {})
        if (params.callback) params.callback()
      })
    },
    // Excel 取込
    [IMPORT_PAYROLL_DOCUMENTS] ({dispatch, state, commit}, params) {
      state.payrollImportResult = null
      return dispatch('apiPost', {url: '/master/payroll/documents/import', data: params.data, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(IMPORT_PAYROLL_DOCUMENTS_FAILURE, res.data)
          } else {
            commit(IMPORT_PAYROLL_DOCUMENTS_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '取込に失敗しました。'
        commit(IMPORT_PAYROLL_DOCUMENTS_FAILURE, {error: message})
      })
    },
    // 明細PDFのダウンロード用署名URL（有効5分・ワンタイム）を発行する
    [GET_PAYROLL_DOWNLOAD_URL] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/payroll/documents/' + params.id + '/download_url', data: {}})
      .then(res => {
        if (res.data && res.data.error) {
          commit(GET_PAYROLL_DOWNLOAD_URL_FAILURE, res.data)
          return
        }
        if (params.callback) {
          params.callback(res.data)
        }
      })
      .catch(error => {
        var message = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error : 'ダウンロードURLの取得に失敗しました。'
        commit(GET_PAYROLL_DOWNLOAD_URL_FAILURE, {error: message})
      })
    },
    // 給与・賞与明細の対象外設定
    [UPDATE_PAYROLL_EXCLUDED] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/users/update_payroll_excluded', data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(UPDATE_PAYROLL_EXCLUDED_FAILURE, res.data)
          } else {
            commit(UPDATE_PAYROLL_EXCLUDED_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '保存に失敗しました。'
        commit(UPDATE_PAYROLL_EXCLUDED_FAILURE, {error: message})
      })
    }
  },
  mutations: {
    [GET_PAYROLL_DOCUMENTS_FAILURE] (state, data) {
      console.log('GET_PAYROLL_DOCUMENTS_FAILURE')
      state.payrollDocuments = []
    },
    [GET_PAYROLL_DOCUMENTS_SUCCESS] (state, data) {
      console.log('GET_PAYROLL_DOCUMENTS_SUCCESS')
      state.payrollDocuments = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [GET_PAYROLL_DOCUMENT_FAILURE] (state, data) {
      console.log('GET_PAYROLL_DOCUMENT_FAILURE')
      state.payrollDocument = null
    },
    [GET_PAYROLL_DOCUMENT_SUCCESS] (state, data) {
      console.log('GET_PAYROLL_DOCUMENT_SUCCESS')
      state.payrollDocument = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [IMPORT_PAYROLL_DOCUMENTS_FAILURE] (state, data) {
      console.log('IMPORT_PAYROLL_DOCUMENTS_FAILURE')
      state.payrollNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.payrollNotify = null
      }, constant.notifyShowTime.long)
    },
    [IMPORT_PAYROLL_DOCUMENTS_SUCCESS] (state, data) {
      console.log('IMPORT_PAYROLL_DOCUMENTS_SUCCESS')
      state.payrollImportResult = data.data
      state.payrollNotify = {message: data.data.success, danger: false}
      setTimeout(() => {
        state.payrollNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    },
    [GET_PAYROLL_DOWNLOAD_URL_FAILURE] (state, data) {
      console.log('GET_PAYROLL_DOWNLOAD_URL_FAILURE')
      state.payrollNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.payrollNotify = null
      }, constant.notifyShowTime.long)
    },
    [UPDATE_PAYROLL_EXCLUDED_FAILURE] (state, data) {
      console.log('UPDATE_PAYROLL_EXCLUDED_FAILURE')
      state.payrollNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.payrollNotify = null
      }, constant.notifyShowTime.long)
    },
    [UPDATE_PAYROLL_EXCLUDED_SUCCESS] (state, data) {
      console.log('UPDATE_PAYROLL_EXCLUDED_SUCCESS')
      state.payrollNotify = {message: data.data.success, danger: false}
      setTimeout(() => {
        state.payrollNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payroll.js